import { FC } from "react";
import { Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReloadAction } from "./ErrorMessage";

const ErrorMessageActions: FC<{ actions: Array<ReloadAction> }> = ({ actions }) => {
	const { t } = useTranslation(["common", "errors"]);
	if (actions.length <= 0) {
		return <></>; // No accept actions available.
	}

	return (
		<Stack direction="column" spacing={2}>
			{actions.map((action, index) => (
				<>
					{index === 1 && <Typography>- {t("common:or")} -</Typography>}
					<Button type="button" variant={index <= 0 ? "contained" : "text"} onClick={action.onClick}>
						{action.title ?? t("errors:retry")}
					</Button>
				</>
			))}
		</Stack>
	);
};

export default ErrorMessageActions;
